import { Clear } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DisplayNoResult from './DisplayNoResult';

export default function SearchNoResult({
  searchText,
  onClearSearch,
}: {
  searchText?: string;
  onClearSearch?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <DisplayNoResult message={searchText ? t('filter.noResultSearchWithText', { searchText }) : t('general.noResult')}>
      {onClearSearch && (
        <Button
          variant="outlined"
          size="large"
          sx={{ borderRadius: 10, p: 1.5, borderWidth: 2, fontWeight: 600, textAlign: 'center', whiteSpace: 'nowrap' }}
          onClick={onClearSearch}
          data-qa-element-id="clear_search_button"
          startIcon={<Clear />}
        >
          {t('filter.clearSearch')}
        </Button>
      )}
    </DisplayNoResult>
  );
}
